/**
 * supporterCollaborationService — NON-FINANCIAL "Express Interest" collaboration
 * for the four TB supporter personas (individual / NGO / corporate / nutrition).
 * Wraps /supporters/collaboration/**. Carries no amount, payment or monetary data.
 */
import api from './api'
import type { ApiResponse } from '../types'

export type CollaborationStatus = 'SUBMITTED' | 'REVIEWED'

export interface SupporterCollaborationInterest {
  id: number
  userType?: string
  interestType: string
  title?: string
  message?: string
  status: CollaborationStatus
  createdAt: string
}

export interface SupporterCollaborationRequest {
  interestType: string
  title?: string
  message?: string
}

/** POST /supporters/collaboration/express — submit a non-financial collaboration interest. */
export async function expressInterest(
  req: SupporterCollaborationRequest,
): Promise<SupporterCollaborationInterest> {
  const res = await api.post<ApiResponse<SupporterCollaborationInterest>>(
    '/supporters/collaboration/express',
    req,
  )
  return res.data.data
}

/** GET /supporters/collaboration/my — the caller's own submitted interests. */
export async function getMyCollaborationInterests(): Promise<SupporterCollaborationInterest[]> {
  const res = await api.get<ApiResponse<SupporterCollaborationInterest[]>>(
    '/supporters/collaboration/my',
  )
  return res.data.data
}

export const COLLABORATION_STATUS_LABELS: Record<CollaborationStatus, string> = {
  SUBMITTED: 'Submitted',
  REVIEWED: 'Reviewed',
}